import { MapPin, ArrowUpRight } from "lucide-react";
import { CONTACT } from "../data/site";

export const MapEmbed = () => {
  const q = encodeURIComponent(`Av. Victor Maida, 517, Ibitinga - SP`);
  return (
    <div data-testid="footer-map" className="mt-16 grid lg:grid-cols-12 gap-6 items-stretch">
      <div className="lg:col-span-8 relative h-64 sm:h-80 overflow-hidden border border-paper/15 bg-paper/5">
        <iframe
          title="Mapa Alfa Gráfica Digital"
          src={`https://maps.google.com/maps?q=${q}&z=16&output=embed`}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="absolute inset-0 h-full w-full grayscale-[0.6] contrast-[1.05]"
        />
      </div>
      <div className="lg:col-span-4 flex flex-col justify-between gap-6 border border-paper/15 p-6">
        <div>
          <MapPin className="h-6 w-6 text-alga" />
          <p className="mt-4 font-display uppercase text-xl leading-tight">Venha até a gráfica</p>
          <p className="mt-2 text-sm text-paper/80">{CONTACT.address}</p>
        </div>
        <a
          href={`https://www.google.com/maps/dir/?api=1&destination=${q}`}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-map-directions"
          className="group inline-flex items-center justify-between gap-4 rounded-full bg-alga text-ink pl-6 pr-2 py-2 text-sm font-bold uppercase tracking-wide transition-transform duration-300 hover:-translate-y-0.5 active:scale-95"
        >
          Como chegar
          <span className="grid place-items-center h-9 w-9 rounded-full bg-ink text-paper transition-transform duration-500 group-hover:rotate-45"><ArrowUpRight className="h-4 w-4" /></span>
        </a>
      </div>
    </div>
  );
};
